import React, { useEffect, useState } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { toast } from "react-hot-toast";
import { BsFillCreditCard2BackFill } from "react-icons/bs";
import { BASE_URL } from "../utils/tools";
import { Button } from "@jammable/ui-core";
import { Spinner } from "@jammable/ui-components/Loader";
import { formatPriceWithLocale } from "@/utils/pricing";

const StripePaymentElement = ({ price, discount, currency }) => {
  const stripe = useStripe();
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);
  const elements = useElements();

  useEffect(() => {
    if (elements) {
      const element = elements.getElement("payment");
      element.on("ready", () => {});
      element.on("change", () => {
        setError(null);
      });
    }
  }, [elements]);

  async function handleCheckoutFormSubmit(event) {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }
    setLoading(true);

    const stripePayload = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${BASE_URL}/thankyou`,
      },
    });
    setLoading(false);
    if (stripePayload.error) {
      setLoading(false);
      // dispatch(actions.errorGlobal(stripePayload.error.message));
      if (stripePayload?.error?.message === "Your card has been declined.") {
        setError(
          "Your card has been declined. Please contact your bank or try a different payment method.",
        );
      } else {
        setError(stripePayload?.error?.message);
      }
    } else {
      toast.success(`Thank you for your purchase!`);
    }
    setLoading(false);
  }

  return (
    <form style={{ marginBottom: 0 }} onSubmit={handleCheckoutFormSubmit}>
      {error && (
        <div
          style={{ marginBottom: 20, padding: 15 }}
          className="error-message"
        >
          {error}
        </div>
      )}

      <div style={{ minHeight: "200px" }}>
        <PaymentElement />
      </div>

      <Button
        className="tw-font-black tw-uppercase tw-text-base tw-rounded-2xl tw-w-full tw-h-14 tw-flex tw-justify-center tw-items-center tw-border tw-border-solid tw-border-purple-700 tw-border-b-4 tw-border-b-purple-900 active:tw-translate-y-0.5 active:tw-border-b-2 active:tw-scale-[0.98] tw-transition tw-duration-100 tw-ease-in-out disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
        type="submit"
      >
        {loading ? (
          <Spinner className="tw-border-white" size={4} />
        ) : (
          <div className="tw-flex tw-items-center tw-gap-2">
            <BsFillCreditCard2BackFill size={20} />
            <div>
              Pay{" "}
              <span
                style={{
                  color: discount && "lightgreen",
                }}
              >
                {formatPriceWithLocale(price, currency)}
              </span>{" "}
            </div>
          </div>
        )}
      </Button>
    </form>
  );
};

export default StripePaymentElement;
